module.exports = __webpack_public_path__ + "img/circle_white.af06a957.png";